<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="listdata_keyno" [ttModel]="edit.listdata_keyno" ttReadonly></tt-input>
        <tt-input *ngIf="listDataKeyno === '0'" ttLabel="listdatalang_name" [(ttModel)]="edit.listdatalang_name" ttRequired></tt-input>
        <tt-input *ngIf="listDataKeyno !== '0'" ttLabel="listdatalang_name" [(ttModel)]="edit.listdatalang_name" [ttButtons]="listDataLangButtons" ttRequired></tt-input>
        <tt-button-save ttText="save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>
